export default function genererCritereRechercheConstatationCharge() {
  return {
    etat: [],
    datePivotConstatationChargeContrat: new Date(),
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    datesValidite: {
      dateDebut: null,
      dateFin: null,
    },
    codeDossier: null,
    tiersId: [],
  };
}
